import { message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useState } from 'react';

interface CopyableTextProps {
  text: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const CopyableText = ({ text, children, style }: CopyableTextProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      message.success('Copied to clipboard');
    } catch (err) {
      message.error('Failed to copy');
    }
  };

  return (
    <span
      onClick={handleCopy}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: 'pointer',
        position: 'relative',
        display: 'inline-block',
        ...style,
      }}
    >
      {children}
      {isHovered && (
        <CopyOutlined
          style={{
            marginLeft: '8px',
            fontSize: '12px',
            color: '#1890ff',
          }}
        />
      )}
    </span>
  );
};
